module.exports = __webpack_public_path__ + "static/media/Register-Now_Icon.2414ddab.svg";